import styled, { css } from "styled-components";
import { StyledTabsButton } from "../../styles";
import { defaultTheme } from "storybook/themes/default";

const { colors } = defaultTheme;

export const BaseTabsButtonDefault = styled(StyledTabsButton)<{
  $disabled?: boolean;
  $mobileStackTabs: boolean;
  $maxWidth: string;
}>`
  display: flex;
  box-sizing: border-box;
  padding: 8px 14px;
  border-radius: 0.5rem;
  line-height: 23px;
  font-size: 1.125rem;
  align-items: center;
  align-self: stretch;
  justify-content: center;
  color: ${colors.ciqBrand};

  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;
      color: ${colors.grey};
    `}

  /* IE 11 */
  *::-ms-backdrop,
  & {
    padding: 20px;

    ${({ $mobileStackTabs }) =>
      $mobileStackTabs &&
      css`
        @media (min-width: 600px) {
          padding: 8px 14px;
        }
      `}
  }
`;

export const TabsBtnContained = styled(BaseTabsButtonDefault)<{
  $maxWidth: string;
  $active: boolean;
}>`
  max-width: ${({ $maxWidth }) => $maxWidth || "100%"};

  ${({ $active }) =>
    $active &&
    `
    cursor: default;
    color: ${colors.hematite};
    background-color: ${colors.white};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);`}
`;

export const TabsBtnHeavy = styled(StyledTabsButton)<{
  $maxWidth: string;
  $active: boolean;
}>`
  flex: 1 1 0;
  min-width: 0;
  height: 44px;
  background: transparent;
  overflow-x: visible;
  overflow-y: visible;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500; // Required by consuming applications
  font-variation-settings: "wght" 500; // Required by Storybook
  max-width: ${({ $maxWidth }) => $maxWidth || "100%"};

  ${({ $active }) =>
    $active &&
    `
    color: ${colors.hematite};
    position: relative;

    &::disabled {
      color: ${colors.disabledLight};
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -9px;
      left: 0;
      width: 100%;
      height: 8px;
      background-color: #53b095;
      border-radius: 2px;
    }`}
`;

export const TabsBtnSoft = styled(StyledTabsButton)<{
  $maxWidth: string;
  $active: boolean;
}>`
  max-width: ${({ $maxWidth }) => $maxWidth || "100%"};
  flex: 1 1 0;
  min-width: 0;
  height: 48px;
  font-size: 14px;
  overflow: visble;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #00000099;
  border-color: ${colors.ciqBrand};
  font-weight: 500; // Required by consuming applications
  font-variation-settings: "wght" 500; // Required by Storybook

  &::disabled {
    color: ${colors.disabledLight};
  }

  ${({ $active }) =>
    $active &&
    `
    font-weight: 700; // Required by consuming applications
    font-variation-settings: "wght" 700; // Required by Storybook
    background-color: #c7e7d8;
    position: relative;
    color: #616162;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      z-index: 1;
      background-color: #7f90ef;
    }`}
`;
